<div class="ns-wrapper">

  <!-- Page Header -->
  <div class="ns-page-header">
    <div class="ns-header-left">
      <span class="ns-eyebrow">Applicant Management</span>
      <h2 class="ns-title">New Signups &mdash; {{ monthName }} {{ responseYear }}</h2>
      <p class="ns-subtitle" *ngIf="!isLoading && !errorMessage">
        <strong>{{ allApplicants.length }}</strong> applicant{{ allApplicants.length !== 1 ? 's' : '' }} registered this month
      </p>
    </div>
    <button class="ns-btn-refresh" (click)="loadData()" [disabled]="isLoading">
      <span class="refresh-icon" [class.spinning]="isLoading">↻</span>
      {{ isLoading ? 'Loading...' : 'Refresh' }}
    </button>
  </div>

  <!-- Stat Cards -->
  <div class="ns-stats-row" *ngIf="!errorMessage">
    <div class="ns-stat-card ns-stat-featured">
      <div class="ns-stat-icon">👥</div>
      <div class="ns-stat-body">
        <div class="ns-stat-label">Total Signups</div>
        <div class="ns-stat-value">
          <span *ngIf="!isLoading">{{ allApplicants.length }}</span>
          <span *ngIf="isLoading" class="ns-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ns-stat-sub">This month</div>
      </div>
    </div>
    <div class="ns-stat-card">
      <div class="ns-stat-icon">✅</div>
      <div class="ns-stat-body">
        <div class="ns-stat-label">Paid</div>
        <div class="ns-stat-value">
          <span *ngIf="!isLoading">{{ statPaid }}</span>
          <span *ngIf="isLoading" class="ns-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ns-stat-sub">Payment confirmed</div>
      </div>
    </div>
    <div class="ns-stat-card">
      <div class="ns-stat-icon">⏳</div>
      <div class="ns-stat-body">
        <div class="ns-stat-label">Pending</div>
        <div class="ns-stat-value">
          <span *ngIf="!isLoading">{{ statPending }}</span>
          <span *ngIf="isLoading" class="ns-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ns-stat-sub">Awaiting payment</div>
      </div>
    </div>
    <div class="ns-stat-card">
      <div class="ns-stat-icon">🔐</div>
      <div class="ns-stat-body">
        <div class="ns-stat-label">Verified</div>
        <div class="ns-stat-value">
          <span *ngIf="!isLoading">{{ statVerified }}</span>
          <span *ngIf="isLoading" class="ns-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ns-stat-sub">Account verified</div>
      </div>
    </div>
    <div class="ns-stat-card">
      <div class="ns-stat-icon">🌍</div>
      <div class="ns-stat-body">
        <div class="ns-stat-label">International</div>
        <div class="ns-stat-value">
          <span *ngIf="!isLoading">{{ statInternational }}</span>
          <span *ngIf="isLoading" class="ns-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ns-stat-sub">Foreign students</div>
      </div>
    </div>
    <div class="ns-stat-card">
      <div class="ns-stat-icon">🇬🇭</div>
      <div class="ns-stat-body">
        <div class="ns-stat-label">Ghanaian</div>
        <div class="ns-stat-value">
          <span *ngIf="!isLoading">{{ statGhanaian }}</span>
          <span *ngIf="isLoading" class="ns-skeleton" style="width:40px;height:28px;display:inline-block"></span>
        </div>
        <div class="ns-stat-sub">Local students</div>
      </div>
    </div>
  </div>

  <!-- Toolbar -->
  <div class="ns-toolbar" *ngIf="!errorMessage">
    <div class="ns-search-wrap">
      <svg class="ns-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
      </svg>
      <input
        class="ns-search-input"
        type="text"
        placeholder="Search by name, email or reference…"
        [(ngModel)]="searchQuery"
        (input)="onSearch()" />
      <button class="ns-search-clear" *ngIf="searchQuery" (click)="searchQuery=''; onSearch()">✕</button>
    </div>
    <div class="ns-filter-group">
      <button class="ns-filter-btn" [class.active]="activeFilter === 'ALL'" (click)="setFilter('ALL')">All</button>
      <button class="ns-filter-btn" [class.active]="activeFilter === 'PAID'" (click)="setFilter('PAID')">
        <span class="ns-dot dot-green"></span> Paid
      </button>
      <button class="ns-filter-btn" [class.active]="activeFilter === 'PENDING'" (click)="setFilter('PENDING')">
        <span class="ns-dot dot-amber"></span> Pending
      </button>
      <button class="ns-filter-btn" [class.active]="activeFilter === 'INTERNATIONAL'" (click)="setFilter('INTERNATIONAL')">🌍 International</button>
      <button class="ns-filter-btn" [class.active]="activeFilter === 'GHANAIAN'" (click)="setFilter('GHANAIAN')">🇬🇭 Ghanaian</button>
    </div>
  </div>

  <!-- Table Container -->
  <div class="ns-table-wrap">

    <!-- Loading Skeletons -->
    <div *ngIf="isLoading" class="ns-skeleton-wrap">
      <div class="ns-skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7]">
        <div class="ns-skeleton" style="width:24px"></div>
        <div style="display:flex;align-items:center;gap:10px">
          <div class="ns-skeleton" style="width:34px;height:34px;border-radius:50%;flex-shrink:0"></div>
          <div style="display:flex;flex-direction:column;gap:6px">
            <div class="ns-skeleton" style="width:130px"></div>
            <div class="ns-skeleton" style="width:160px;height:10px"></div>
          </div>
        </div>
        <div class="ns-skeleton" style="width:110px"></div>
        <div class="ns-skeleton" style="width:130px"></div>
        <div class="ns-skeleton" style="width:70px"></div>
        <div class="ns-skeleton" style="width:60px"></div>
        <div class="ns-skeleton" style="width:65px"></div>
        <div class="ns-skeleton" style="width:55px"></div>
        <div class="ns-skeleton" style="width:90px"></div>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="!isLoading && errorMessage" class="ns-state-box">
      <div class="ns-state-icon">⚠️</div>
      <div class="ns-state-title">Could not load data</div>
      <div class="ns-state-sub">{{ errorMessage }}</div>
      <button class="ns-btn-refresh" style="margin-top:16px" (click)="loadData()">Try Again</button>
    </div>

    <!-- Table -->
    <table *ngIf="!isLoading && !errorMessage">
      <thead>
        <tr>
          <th></th>
          <th>#</th>
          <th>Applicant</th>
          <th>Phone</th>
          <th>Reference ID</th>
          <th>Type</th>
          <th>Amount</th>
          <th>Payment</th>
          <th>Verified</th>
          <th>Date Registered</th>
        </tr>
      </thead>
      <tbody>

        <!-- Empty State -->
        <tr *ngIf="pagedApplicants.length === 0">
          <td colspan="10">
            <div class="ns-state-box">
              <div class="ns-state-icon">🔍</div>
              <div class="ns-state-title">No applicants found</div>
              <div class="ns-state-sub">Try adjusting your search or filter criteria</div>
            </div>
          </td>
        </tr>

        <ng-container *ngFor="let a of pagedApplicants; let i = index">

          <!-- Main Row -->
          <tr [class.row-expanded]="expandedRowId === a.id" (click)="toggleRow(a.id)" class="ns-data-row">
            <td class="td-chevron">
              <span class="chevron" [class.open]="expandedRowId === a.id">›</span>
            </td>
            <td class="td-index">{{ pageStart + i }}</td>
            <td>
              <div class="ns-td-name">
                <div class="ns-avatar">{{ getInitials(a) }}</div>
                <div>
                  <div class="ns-name">{{ a.firstname }} {{ a.lastname }}</div>
                  <div class="ns-email">{{ a.email }}</div>
                </div>
              </div>
            </td>
            <td class="td-muted">{{ a.phoneNumber || '—' }}</td>
            <td><span class="ns-ref-code">{{ a.referenceID || '—' }}</span></td>
            <td>
              <span class="ns-badge" [ngClass]="a.typeofStudent === 'INTERNATIONAL' ? 'badge-intl' : 'badge-local'">
                {{ a.typeofStudent === 'INTERNATIONAL' ? '🌍 Intl' : '🇬🇭 Ghanaian' }}
              </span>
            </td>
            <td class="td-amount">GH₵ {{ a.amount | number:'1.2-2' }}</td>
            <td>
              <span class="ns-badge" [ngClass]="a.paymentStatus === 'PAID' ? 'badge-paid' : 'badge-pending'">
                <span class="ns-dot" [ngClass]="a.paymentStatus === 'PAID' ? 'dot-green' : 'dot-amber'"></span>
                {{ a.paymentStatus === 'PAID' ? 'Paid' : 'Pending' }}
              </span>
            </td>
            <td>
              <span class="ns-badge" [ngClass]="a.verified ? 'badge-verified' : 'badge-unverified'">
                {{ a.verified ? '✓ Yes' : '✗ No' }}
              </span>
            </td>
            <td class="td-muted td-date">{{ formatDate(a.createdAt) }}</td>
          </tr>

          <!-- Expanded Detail Row -->
          <tr class="ns-detail-row" *ngIf="expandedRowId === a.id">
            <td colspan="10">
              <div class="ns-detail-panel">
                <div class="ns-detail-grid">

                  <div class="ns-detail-group">
                    <div class="ns-detail-label">Applicant ID</div>
                    <div class="ns-detail-value">#{{ a.id }}</div>
                  </div>

                  <div class="ns-detail-group">
                    <div class="ns-detail-label">PIN</div>
                    <div class="ns-detail-value">
                      <span class="ns-secret-code">{{ a.pin || '—' }}</span>
                    </div>
                  </div>

                  <div class="ns-detail-group">
                    <div class="ns-detail-label">OTP Code</div>
                    <div class="ns-detail-value">
                      <span class="ns-secret-code">{{ a.otpCode || '—' }}</span>
                    </div>
                  </div>

                  <div class="ns-detail-group">
                    <div class="ns-detail-label">OTP Expires At</div>
                    <div class="ns-detail-value">{{ formatDate(a.otpExpiresAt) }}</div>
                  </div>

                  <div class="ns-detail-group ns-detail-wide">
                    <div class="ns-detail-label">Checkout ID</div>
                    <div class="ns-detail-value">
                      <span class="ns-ref-code">{{ a.checkoutId || '—' }}</span>
                    </div>
                  </div>

                  <div class="ns-detail-group">
                    <div class="ns-detail-label">Last Updated</div>
                    <div class="ns-detail-value">{{ formatDate(a.updatedAt) }}</div>
                  </div>

                  <div class="ns-detail-group">
                    <div class="ns-detail-label">Reset Token</div>
                    <div class="ns-detail-value">
                      <span class="ns-badge badge-unverified" *ngIf="a.resetToken">Active</span>
                      <span class="ns-badge badge-local" *ngIf="!a.resetToken">None</span>
                    </div>
                  </div>

                </div>
              </div>
            </td>
          </tr>

        </ng-container>

      </tbody>
    </table>

    <!-- Pagination -->
    <div class="ns-pagination" *ngIf="!isLoading && !errorMessage && filteredApplicants.length > 0">
      <span class="ns-page-info">
        Showing <strong>{{ pageStart }}–{{ pageEnd }}</strong> of <strong>{{ filteredApplicants.length }}</strong> applicants
        &nbsp;·&nbsp; <span style="color:#aaa">click a row to expand details</span>
      </span>
      <div class="ns-page-btns">
        <button class="ns-page-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">&#8249;</button>
        <button
          *ngFor="let p of pages"
          class="ns-page-btn"
          [class.active]="p === currentPage"
          (click)="goToPage(p)">
          {{ p }}
        </button>
        <button class="ns-page-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">&#8250;</button>
      </div>
    </div>

  </div>
  <br>

  <app-newsignupsmonthlygraph></app-newsignupsmonthlygraph>
  <div class="ns-stats-row" *ngIf="!errorMessage">


</div>

<!-- Monthly Graph -->

<!-- Stat Cards -->
  